import React, { useLayoutEffect } from 'react';
import {
  Content,
  ContentContainer,
  PageContainer,
  Title,
  BoldText,
  Text,
  StyledSubtitle,
} from './Hikes.styles';
import { useTranslation } from 'react-i18next';
import { PhotoGallery } from './PhotoGallery';
import { imagesMadera } from './images';

export const Madera = () => {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>{t('hiking.madera')}</Title>

          <BoldText>{t('hiking.destination-madera')}</BoldText>
          <BoldText>{t('hiking.date-madera')}</BoldText>
          <Text>{t('madera.description')}</Text>

          <StyledSubtitle>{t('madera.subtitle0')}</StyledSubtitle>
          <Text>{t('madera.description0')}</Text>

          <StyledSubtitle>{t('madera.subtitle1')}</StyledSubtitle>
          <Text>{t('madera.description1')}</Text>

          <StyledSubtitle>{t('madera.subtitle2')}</StyledSubtitle>
          <Text>{t('madera.description2')}</Text>

          <StyledSubtitle>{t('madera.subtitle3')}</StyledSubtitle>
          <Text>{t('madera.description3')}</Text>

          <StyledSubtitle>{t('madera.subtitle4')}</StyledSubtitle>
          <Text>{t('madera.description4')}</Text>

          <StyledSubtitle>{t('madera.subtitle5')}</StyledSubtitle>
          <Text>{t('madera.description5')}</Text>

          <StyledSubtitle>{t('madera.subtitle6')}</StyledSubtitle>
          <Text>{t('madera.description6')}</Text>

          <PhotoGallery images={imagesMadera} />
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};
